export default {
    install: (Vue, { router }) => {
        Vue.router = router;

        let homeRoute = () => Vue.state.client.get().view.routing.homeRoute || 'casino-home';

        Vue.router.resolver = {
            gameBack() {
                let backRoute = Vue.router.routeHistoryArray.find(rh => {
                    let route = rh.matched.find(r => r.name === rh.name);
                    return route.props && route.props.default && route.props.default.backFromGame;
                });
                if (backRoute) return backRoute;
                return Vue.router.resolve({ name: homeRoute() }).route;
            }
        }

        Vue.router.teleport = {
            home() {
                if (Vue.router.currentRoute.name == homeRoute()) {
                    Vue.router.go();
                } else {
                    Vue.router.push({ name: homeRoute() });
                }
            },
            game(game) {
                if (game.provider == 'hdraces') {
                    Vue.router.push({ name: 'virtual-sport-hdraces', params: { game: game.gameId } })
                } else {
                    Vue.router.push({ name: 'game', params: { provider: game.provider, game: game.gameId } })
                }
            },
            async afterRegistration() {
                await Vue.state.client.ensure();
                let client = Vue.state.client.get();
                if (client.view.routing.redirectToDepositAfterRegistration) {
                    await Vue.state.player.ensure();
                    let player = Vue.state.player.get();
                    if (client.paymentSystem.paymentSystemAllowed) {
                        Vue.router.push({
                            name: 'balance.operation',
                            params: {
                                balanceId: (player && player.balance && player.balance.id) || null,
                                type: 'deposit'
                            }
                        });
                    } else {
                        Vue.router.push({ name: 'activate-code' });
                    }
                } else {
                    Vue.router.teleport.home();
                }
            },
            async bonusRules() {
                await Vue.state.client.ensure();
                let client = Vue.state.client.get();
                let bonusRulesRouteName = client.view.legal.bonusRulesRoute || 'bonus-rules';
                Vue.router.push({ name: bonusRulesRouteName });
            },
            async onUnauthorized() {
                await Vue.state.client.ensure();
                let client = Vue.state.client.get();
                let loginAllowed = client && client.loginTypes && client.loginTypes.length;
                if (loginAllowed) {
                    Vue.router.push({ name: 'login' });
                } else {
                    Vue.router.teleport.home();
                }
            }
        };
    }
};



// WEBPACK FOOTER //
// ./_common/plugins/router.plugin.js